import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SurgeryAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-surgery-slot',
    templateUrl: './surgery-slot.component.html',
    styleUrl: './surgery-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurgerySlotComponent implements SheetSlotComponentBase {

	@Input() action!: SurgeryAction;
	value = null;

	constructor() {
	}
}